// App.jsx
import React, { useState, useEffect } from 'react';
import LinkButton from './LinkButton';
import { Helmet } from 'react-helmet-async';
import './App.css';
// Importar iconos de react-icons (ejemplo: necesitarás instalar react-icons)
import { FaStore, FaInstagram, FaTiktok, FaShareAlt, FaStar } from 'react-icons/fa';
import CookieConsent from './CookieConsent'; // Importamos el nuevo componente

// Datos de los enlaces
const linksData = [
  { icon: FaStore, text: 'Mira mi catálogo!!', link: 'https://wa.me/c/34633474564' },
  { icon: FaInstagram, text: 'Instagram', link: 'https://www.instagram.com/kukisresin' },
  { icon: FaTiktok, text: 'TikTok', link: 'https://www.tiktok.com/@kukisresin' },
];

const App = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  // Función para guardar en favoritos (bookmark)
  const handleBookmark = () => {
    alert('Presiona Ctrl+D (o ⌘+D en Mac) para guardar esta página en tus favoritos.');
  };

  // Función para compartir usando la Web Share API
  const handleShare = async () => {
    const shareData = {
      title: 'Kukisresin - Artesanía en Resina',
      text: '¡Echa un vistazo a los productos de artesanía en resina de Kukisresin!',
      url: window.location.href, // URL actual de la página
    };

    try {
      // Comprueba si el navegador soporta la API de compartir
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback para navegadores que no lo soportan (ej: copiar al portapapeles)
        await navigator.clipboard.writeText(window.location.href);
        //alert('¡Enlace copiado al portapapeles!');
      }
    } catch (error) {
      console.error('Error al intentar compartir:', error);
      // Opcional: mostrar un mensaje de error al usuario si falla
      //alert('No se pudo compartir el contenido.');
    }
  };

  // Función para aceptar las cookies
  const handleAcceptCookies = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShowCookieBanner(false);
  };

  // --- Datos para las metaetiquetas ---
  // ¡IMPORTANTE! Reemplaza esta URL por la URL final de tu sitio web
  const pageUrl = "https://kukisresin.vercel.app/";
  const title = "Kukisresin - Productos de artesanía";
  const description = "¡Echa un vistazo a los productos de artesanía en resina hecha a mano de Kukisresin: llaveros, colgantes, imanes y más!";
  const imageUrl = `${pageUrl}kukisresinlogoweb.webp`;

  return (
    <div className="app-container">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />

        {/* Open Graph / Facebook / WhatsApp */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imageUrl} />
      </Helmet>

      {/* Encabezado con iconos */}
      <header className="header">
        {/* <FaStar size={24} color="#0D1117" onClick={handleBookmark} style={{ cursor: 'pointer' }} /> */}
        <FaShareAlt size={24} color="#0D1117" onClick={handleShare} style={{ cursor: 'pointer' }} />
      </header>

      {/* Contenido principal del perfil */}
      <main className="profile-container">
        {/* Imagen de perfil (simulada) */}
        <div className="profile-image-wrapper">
          {/*  -> Si tuvieras un servicio de imágenes para usar */}
          <img
            src="/kukisresinlogoweb.webp" // Reemplaza con la ruta de tu logo
            alt="Logo de kukisresin"
            className="profile-image"
            style={{
              width: '96px',
              height: '96px',
              borderRadius: '50%',
              border: '2px solid white',
              marginBottom: '16px'
            }}
          />
        </div>

        {/* Nombre de usuario y descripción */}
        <h1 style={{ fontSize: '24px', color: '#0D1117', margin: '0 0 8px 0' }}>kukisresin</h1>
        <p className="description">
          ¡Hola, bienvenid@! Aquí están mis RRSS para que
          puedas ver mis productos de artesanía en resina
          hecha a mano: llaveros, colgantes, imanes y más.
        </p>

        {/* Lista de botones de enlaces */}
        <div className="links-list">
          {linksData.map((item, index) => (
            <LinkButton
              key={index}
              icon={item.icon}
              text={item.text}
              link={item.link}
            />
          ))}
        </div>

        {/* Botón inferior de Linktree (simulado) */}
        {/* <a
          href="https://linktr.ee/kukisresin"
          target="_blank"
          rel="noopener noreferrer"
          className="linktree-join-button"
          style={{
            marginTop: '32px',
            backgroundColor: '#0D1117', // Fondo oscuro como el original
            color: 'white',
            padding: '12px 24px',
            borderRadius: '24px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'inline-block'
          }}
        >
          Únete a kukisresin en Linktree
        </a> */}
      </main>

      {/* Pie de página */}
      {/* <footer className="footer">
        <a href="#preferences">Cookie Preferences</a>
        · <a href="#report">Report</a>
        · <a href="#privacy">Privacy</a>
      </footer> */}

      {/* Renderizado condicional del banner de cookies */}
      {showCookieBanner && <CookieConsent onAccept={handleAcceptCookies} />}
    </div>
  );
};

export default App;